module.exports = __webpack_public_path__ + "img/chair_hot_off.6d820efb.png";